import { Address } from "./address";

export enum PERSON_ACTIVE_STATUS {
  ACTIVE = 1,
  INACTIVE = 0,
}

/** Value of the `activeStatus` query param accepted by the person endpoints. */
export enum PERSON_STATUS_FILTER {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  ALL = 'all',
}

export interface IPerson {
  id?: string;
  name?: string;
  lang?: number;
  gender?: number;
  birthday?: string;
  document?: string;
  phone1?: string;
  phone2?: string;
  email?: string;
  address?: Address;
  maritalStatus?: number;
  photo?: string;
  available?: number;
  observation?: string;
  creditLimit?: number;
  type?: 'Consumidor' | 'Revenda' | 'Fabricante';
  active?: PERSON_ACTIVE_STATUS;
  
  // Absent in the API
  photoBlob?: Blob;
  photoInput?: string;
}
